module.exports = __webpack_public_path__ + "static/media/unstandartWindow.57a8b8d4.jpg";